import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "message_circle",
  "use": "message_circle-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"message_circle\"><g fill-rule=\"evenodd\"><circle cx=\"16\" cy=\"16\" r=\"16\" fill-rule=\"nonzero\" /><path d=\"M24 15.556a7.45 7.45 0 0 1-.8 3.377 7.556 7.556 0 0 1-6.756 4.178 7.449 7.449 0 0 1-3.377-.8L8 24l1.689-5.067a7.449 7.449 0 0 1-.8-3.377A7.556 7.556 0 0 1 13.067 8.8a7.45 7.45 0 0 1 3.377-.8h.445A7.538 7.538 0 0 1 24 15.111v.445z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol